import React from "react";
import { BackQuackItem } from "duck/ui/chat/types";

import Alert from "features/components/Alert";
import Typography from "features/components/Typography";

import { Renderer } from "./types";

const hasMessage = (message?: unknown): message is string =>
  typeof message === "string" && message.trim().length > 0;

export const CriticalErrorMessageRenderer: Renderer<BackQuackItem> = {
  type: "critical_error_message",

  canRender: ({ critical_error_message }: BackQuackItem): boolean =>
    hasMessage(critical_error_message),

  render: ({ critical_error_message }: BackQuackItem): React.ReactNode => {
    if (!hasMessage(critical_error_message)) {
      return null;
    }

    return (
      <Alert severity="error" color="error">
        <Typography variant="body2" className="text-sm font-medium">
          {critical_error_message}
        </Typography>
      </Alert>
    );
  },
};
